<!-- Zweck: Stellt die HTML-Struktur für shop alternativ artikel button component im Frontend bereit. -->
<span matTooltip="{{disabled ? 'Alternative Produkte Suche für diesen Artikel nicht möglich' :'Alternative Produkte' }}">
  <button (click)="check()" (contextmenu)="$event.preventDefault()"
          [disabled]="disabled"
          mat-icon-button>
    <svg-icon>
      produktsuche_alternativ
    </svg-icon>
  </button>
</span>
